import React from 'react';
import { Trans } from '@lingui/macro';
import './Tutorial.scss';

export default function Tutorial(props) {
  return <div className={`tutorial-stage highlight-element lock-others ${props.stageName}-stage`}>
    <div className="tutorial-tooltip-wrap" aligned={props.alignment || 'left'}>
      <div className="tutorial-tooltip">
        <p className="title">{props.title}</p>
        <div>{props.desc}</div>
        <div className="tutorial-button-wrap">
          <button className="button" onClick={props.next}><Trans>NEXT</Trans></button>
        </div>
      </div>
    </div>

    {props.children}
  </div >;
}
